let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2uPxx")).then(() => parcelRequire('V4ByJ'));